import styled from "styled-components"

export const ErrorMessage = styled.p`
    color: red;
    font-size: 16px;
`